export const faqCategoryData = [
  {
    key: "1",
    CATEGORY: "Rental Policies",
    CREATED_DATE: "24 Jan 2025",
    NUMBER_OF_QUESTIONS: "15",
    STATUS: "Published",
  },
  {
    key: "2",
    CATEGORY: "Payments",
    CREATED_DATE: "19 Dec 2024",
    NUMBER_OF_QUESTIONS: "13",
    STATUS: "Unpublish",
  },
  {
    key: "3",
    CATEGORY: "Insurance",
    CREATED_DATE: "11 Dec 2024",
    NUMBER_OF_QUESTIONS: "4",
    STATUS: "Published",
  },
  {
    key: "4",
    CATEGORY: "Rental Policies",
    CREATED_DATE: "29 Nov 2024",
    NUMBER_OF_QUESTIONS: "9",
    STATUS: "Published",
  },
  {
    key: "5",
    CATEGORY: "Booking",
    CREATED_DATE: "03 Nov 2024",
    NUMBER_OF_QUESTIONS: "19",
    STATUS: "Published",
  },
  {
    key: "6",
    CATEGORY: "Requirements",
    CREATED_DATE: "31 Oct 2024",
    NUMBER_OF_QUESTIONS: "17",
    STATUS: "Published",
  },
  {
    key: "7",
    CATEGORY: "Drivers",
    CREATED_DATE: "15 Oct 2024",
    NUMBER_OF_QUESTIONS: "6",
    STATUS: "Unpublish",
  },
  {
    key: "8",
    CATEGORY: "Drivers",
    CREATED_DATE: "26 Sep 2024",
    NUMBER_OF_QUESTIONS: "25",
    STATUS: "Unpublish",
  },
  {
    key: "9",
    CATEGORY: "Pricing",
    CREATED_DATE: "01 Sep 2024",
    NUMBER_OF_QUESTIONS: "18",
    STATUS: "Published",
  },
  {
    key: "10",
    CATEGORY: "Rental Policies",
    CREATED_DATE: "15 Aug 2024",
    NUMBER_OF_QUESTIONS: "18",
    STATUS: "Published",
  },
  {
    key: "11",
    CATEGORY: "Roadside Assistance",
    CREATED_DATE: "15 Aug 2024",
    NUMBER_OF_QUESTIONS: "22",
    STATUS: "Published",
  },
];
